module.exports = __webpack_public_path__ + "static/media/bolso (2).33b1a5d8.jpg";